import { ResultDto } from "../../../Model/CommonModels"
import { DELETE_ASSIGNMENT_LOG, RESUME_SUSPEND_ASSIGNMENT_LOG } from "../../../Model/Log"

const initState: ResultDto = {
    data: undefined,
    info: undefined,
    warning: undefined
}
//const dispatch = useDispatch();


export const AssignmentLogDeleteReducer = (state = initState, action: { type: string, payload: ResultDto }) => {
    switch (action.type) {
        case DELETE_ASSIGNMENT_LOG:
            {
                return { ...state, ResultDto: action.payload }
            }
            case RESUME_SUSPEND_ASSIGNMENT_LOG:
                return { ...state, ResultDto: action.payload }

        default:
            return state;
    }
}
